<template>
  <section class="assignments-filters">
    <div class="section-title">
      <span @click="isOpen = !isOpen">
        {{ $t('assignments.listing.filters.title') }}
        <font-awesome-icon :icon="isOpen ? 'sort-up' : 'sort-down'" />
      </span>
    </div>

    <div v-show="isOpen">
      <div class="filter-inputs">
        <div class="date-range">
          <div class="date-range-label">
            {{ $t('assignments.listing.filters.startsBetweenLabel') }}
          </div>
          <DatePicker
            :value="startDateMin"
            :placeholder="$t('assignments.listing.filters.startDateMin')"
            @change="onDateChange('startDateMin', $event)"
          />
          <span class="hyphen">-</span>
          <DatePicker
            :value="startDateMax"
            :placeholder="$t('assignments.listing.filters.startDateMax')"
            @change="onDateChange('startDateMax', $event)"
          />
        </div>

        <div class="date-range">
          <div class="date-range-label">
            {{ $t('assignments.listing.filters.stopsBetweenLabel') }}
          </div>
          <DatePicker
            :value="stopDateMin"
            :placeholder="$t('assignments.listing.filters.stopDateMin')"
            @change="onDateChange('stopDateMin', $event)"
          />
          <span class="hyphen">-</span>
          <DatePicker
            :value="stopDateMax"
            :placeholder="$t('assignments.listing.filters.stopDateMax')"
            @change="onDateChange('stopDateMax', $event)"
          />
        </div>

        <TolSelect
          :options="statusesForSelect"
          :selected="selectedStatuses"
          :placeholder="$t('assignments.listing.filters.status.all')"
          :multi-select-label="$t('assignments.listing.filters.status.plural')"
          multiple
          @change="onStatusChange"
        />
      </div>
    </div>
  </section>
</template>

<script>
import TolSelect from '@/app/components/TolSelect';
import DatePicker from '@/app/components/DatePicker';

import format from 'date-fns/format';

export default {
  name: 'AssignmentsFilters',
  components: {
    TolSelect,
    DatePicker
  },
  props: {
    currentUser: {
      type: Object,
      required: true
    },
    assignmentsFilters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    startDateMin() {
      return this.assignmentsFilters.dateRangeFilters.startDateMin;
    },
    startDateMax() {
      return this.assignmentsFilters.dateRangeFilters.startDateMax;
    },
    stopDateMin() {
      return this.assignmentsFilters.dateRangeFilters.stopDateMin;
    },
    stopDateMax() {
      return this.assignmentsFilters.dateRangeFilters.stopDateMax;
    },

    statusesForSelect() {
      let returnValue = [];
      Object.keys(this.assignmentsFilters.statusFilters).forEach(s => {
        if (s === 'activeOnline' || s === 'activeOffline') {
          s = s.replace('O', '_o');
        }
        returnValue.push({
          label: this.$t('statuses.' + s),
          value: s
        });
      });
      return returnValue;
    },
    selectedStatuses() {
      return this.statusesForSelect.filter(e => this.assignmentsFilters.statusFilters[e.value]);
    }
  },
  methods: {
    formatDate(d) {
      return d ? format(d, 'YYYY-MM-DD') : null;
    },

    onDateChange(field, newValue) {
      this.$emit('change', {
        ...this.assignmentsFilters,
        dateRangeFilters: {
          ...this.assignmentsFilters.dateRangeFilters,
          [field]: newValue
        }
      });
    },

    onStatusChange: function(multiSelectValue) {
      this.$emit('change', {
        ...this.assignmentsFilters,
        statusFilters: {
          draft: multiSelectValue.includes('draft'),
          submitted: multiSelectValue.includes('submitted'),
          approved: multiSelectValue.includes('approved'),
          activeOnline: multiSelectValue.includes('active_online'),
          activeOffline: multiSelectValue.includes('active_offline'),
          finished: multiSelectValue.includes('finished'),
          rejected: multiSelectValue.includes('rejected'),
          obsolete: multiSelectValue.includes('obsolete')
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.assignments-filters {
  background-color: $background-level-2;

  .section-title {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.22px;
    line-height: 25px;
    margin-bottom: 20px;
    padding: 60px;
    display: flex;
    justify-content: space-between;
    > span {
      cursor: pointer;
    }
  }

  .filter-inputs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0px 60px 60px 60px;

    .date-range {
      display: flex;
      flex-direction: row;
      .date-range-label {
        padding: 10px 10px 5px 0px;
        text-align: center;
        font-weight: bold;
      }

      .date-range-picker {
        display: inline-block;
      }

      .hyphen {
        display: inline-block;
        margin: 0 10px;
      }
    }
  }
}
</style>
